import React, { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import AsyncSelect from "react-select/lib/Async";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import Modal from "react-responsive-modal";
import { AlmacenesPadreApi } from "../api/AlmacenesPadreApi";
import { Controller, useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import moment from "moment";
import { useDebouncedAsyncSelect } from "../../../../../Utils/Hooks/useDebounce";

export const FormAlmacenPadre = (props) => {
    const { opened, onClose, onSuccess, almacenSeleccionado } = props;

    // formulario
    const {
        control: formControl,
        register: formRegister,
        formState: { errors },
        getValues: formGetValues,
        trigger: validateForm,
        reset: formReset,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            nombre: almacenSeleccionado ? almacenSeleccionado.nombre : "",
            acopio: almacenSeleccionado ? almacenSeleccionado.acopio : null,
        },
    });

    useEffect(() => {
        if (almacenSeleccionado) {
            formReset({
                nombre: almacenSeleccionado.nombre,
                acopio: almacenSeleccionado.acopio,
            });
        } else {
            formReset({ nombre: "", acopio: null });
        }
    }, [almacenSeleccionado, formReset]);

    const { crearAlmacenPadre, actualizarAlmacenPadre, getAcopios, cargando } =
        AlmacenesPadreApi();

    const CrearAlmacenPadre = async (data) => {
        try {
            const inventarioCreado = await crearAlmacenPadre(data);

            NotificationManager.success(
                "Almacén padre creado correctamente",
                "Éxito",
                3000,
            );

            formReset({ nombre: "", acopio: null });
            onSuccess();
            onClose();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al crear almacén padre",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const EditarAlmacenPadre = async (data) => {
        try {
            const inventarioActualizado = await actualizarAlmacenPadre(
                almacenSeleccionado.id,
                data,
            );

            NotificationManager.success(
                "Almacén padre actualizado correctamente",
                "Éxito",
                3000,
            );

            formReset({ nombre: "", acopio: null });
            onSuccess();
            onClose();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar almacén padre",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const SubmitForm = async () => {
        const isValid = await validateForm();
        if (!isValid) return;

        const acopio = formGetValues("acopio");

        const data = {
            nombre: formGetValues("nombre"),
            acopio_id: acopio ? acopio.id : null,
        };

        if (almacenSeleccionado) {
            EditarAlmacenPadre(data);
        } else {
            CrearAlmacenPadre(data);
        }
    };

    const loadAcopios = useDebouncedAsyncSelect(function (search) {
        return getAcopios({ search: search });
    });

    return (
        <Modal
            open={opened}
            onClose={onClose}
            closeOnOverlayClick={!cargando}
            focusTrapped={false}
            // limitar ancho con styles
            styles={{
                modal: {
                    maxWidth: "500px",
                    width: "90%",
                },
            }}
        >
            <LoadMask loading={cargando} blur>
                <h2 className="text-center mb-3">Datos de almacén padre</h2>

                <div className="formulario-fields-column gap-1rem">
                    <div className="formulario-field">
                        <label htmlFor="nombre" className="m-0">
                            Nombre del almacén padre
                        </label>

                        <div className="d-flex align-items-center">
                            <div className="flex-1">
                                <input
                                    type="text"
                                    {...formRegister("nombre", {
                                        required: "Este campo es obligatorio",
                                    })}
                                    className="form-control"
                                />
                                {errors.nombre && (
                                    <small className="text-danger">
                                        {errors.nombre.message}
                                    </small>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="formulario-field">
                        <label className="text-nowrap">Acopio</label>
                        <Controller
                            name="acopio"
                            control={formControl}
                            rules={{
                                required: "Debe seleccionar un acopio",
                            }}
                            render={({ field }) => (
                                <AsyncSelect
                                    {...field}
                                    className="react-select-container"
                                    isSearchable
                                    isClearable
                                    cacheOptions
                                    defaultOptions
                                    loadOptions={loadAcopios}
                                    getOptionValue={(option) => option.id}
                                    getOptionLabel={(option) => option.nombre}
                                    onChange={(selected) => {
                                        field.onChange(selected);
                                    }}
                                />
                            )}
                        />
                        {errors.acopio && (
                            <small className="text-danger">
                                {errors.acopio.message}
                            </small>
                        )}
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={onClose}
                        disabled={cargando}
                    >
                        Cancelar
                    </button>
                    <button className="btn btn-primary" onClick={SubmitForm}>
                        {almacenSeleccionado
                            ? "Actualizar almacén padre"
                            : "Crear almacén padre"}
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
